<ng-container *ngIf="profile$ | async as profile">
  <ng-container *ngIf="profile.isLoggedIn">
    <ng-container *ngIf="!isHandheld">
      <div edsGrid edsSpacing="md">
        <div
          edsFlexbox
          flexDirection="row"
          justifyContent="space-between"
          edsSpacing="md"
        >
          <div edsFlexbox flexDirection="row" edsPadding edsPaddingLeft="md">
            <eds-section-header
              [level]="3"
              [isLight]="true"
              theme="primary"
              size="h3"
            >
              {{ "literature.lit-my-literature-title" | translate }}
            </eds-section-header>
          </div>
        </div>
      </div>
      <div edsGrid>
        <div edsRow alignItems="center">
          <div edsCol>
            <div edsSpacing="md" edsPadding edsPaddingLeft="xs">
              <p>
                <b>
                  {{ numberOfData }}
                  {{ "literature.my-literature-items" | translate }}
                </b>
              </p>
              <div edsFlexbox edsSpacing="md">
                <eds-link-item
                  [title]="viewCartTitle"
                  [href]="getNavigateToCartUrl()"
                  edsPadding
                  edsPaddingRight="sm"
                ></eds-link-item>
                <span class="separator"></span>
                <eds-link-item
                  [title]="viewPrevOrdersTitle"
                  [href]="getNavigateToHisoryUrl()"
                  edsPadding
                  edsPaddingLeft="sm"
                ></eds-link-item>
              </div>
            </div>
          </div>
          <!-- Dropdown-->
          <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 2 }">
            <eds-dropdown
              ariaLabel="Dropdown"
              [dropdownId]="'id1'"
              [name]="'name1'"
              [items]="sortByItems"
              [label]="sortByDropDownLabel"
              [preselectedValue]="sortByItems[0]"
              (dropdownChange)="onSorting(rowData, $event)"
            ></eds-dropdown>
          </div>
          <!-- / Dropdown -->
        </div>
        <div edsRow>
          <div edsCol>
            <ag-grid-angular
              stickyHeader
              #literatureDocumentGrid
              style="width: 100%; height: 100%"
              class="ag-theme-frk"
              [rowData]="rowData"
              [columnDefs]="columnDefs"
              [frameworkComponents]="frameworkComponents"
              [noRowsOverlayComponent]="noRowsOverLayCompMyLiterature"
              [rowSelection]="'multiple'"
              [suppressPaginationPanel]="true"
              [suppressHorizontalScroll]="true"
              [suppressRowClickSelection]="true"
              [pagination]="false"
              rowHeight="124"
              domLayout="autoHeight"
              [suppressRowHoverHighlight]="true"
              [suppressCellSelection]="false"
              [ensureDomOrder]="true"
              (rowSelected)="onSelectionChanged($event, href, false, true)"
              (gridReady)="onGridReady($event)"
              [enableCellTextSelection]="true"
            >
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- Mobile view -->
    <ng-container *ngIf="isHandheld">
      <div edsSpacing="md">
        <div
          edsFlexbox
          flexDirection="row"
          justifyContent="space-between"
          edsSpacing="md"
        >
          <div edsFlexbox flexDirection="row" edsPadding edsPaddingLeft="lg">
            <eds-section-header
              [level]="3"
              [isLight]="true"
              theme="primary"
              size="h6"
            >
              My Literature
            </eds-section-header>
          </div>
        </div>
      </div>
      <div edsGrid>
        <div edsRow alignItems="center">
          <div edsCol>
            <div edsSpacing="md" edsPadding edsPaddingLeft="xs">
              <p>
                <b>
                  {{ numberOfData }}
                  {{ "literature.lit-listing-items" | translate }}
                </b>
              </p>
              <div edsFlexbox edsSpacing="md">
                <eds-link-item
                  [title]="viewCartTitle"
                  [href]="getNavigateToCartUrl()"
                  edsPadding
                  edsPaddingRight="sm"
                ></eds-link-item>
                <eds-link-item
                  [title]="viewPrevOrdersTitle"
                  [href]="getNavigateToHisoryUrl()"
                  edsPadding
                  edsPaddingLeft="sm"
                ></eds-link-item>
              </div>
            </div>
          </div>
          <!-- Dropdown-->
          <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 2 }">
            <eds-dropdown
              ariaLabel="Dropdown"
              [dropdownId]="'id1'"
              [name]="'name1'"
              [items]="sortByItems"
              [label]="sortByDropDownLabel"
              [preselectedValue]="sortByItems[0]"
              (dropdownChange)="onSorting(rowData, $event)"
            ></eds-dropdown>
          </div>
          <!-- / Dropdown -->
        </div>

        <ft-literature-document-card-container
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          (selectionEmitter)="onSelectionChanged($event, href, false, true)"
          edsRow
        ></ft-literature-document-card-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<div edsGrid>
  <div edsRow>
    <ft-literature-dialog
      [dialogId]="ModalIdValue"
      [modalIdEnum]="ModalId['Sticky_Modal']"
      [multiSelectDialogData]="multiSelectDialogData"
      (dialog)="closeDialog($event)"
      (deleteDoc)="deselectedDownloadDocs($event)"
      (downloadStart)="startDownload()"
      (emailStart)="startEmail()"
      (modalClose)="closeModal(ModalId['Sticky_Modal'])"
      (backEmail)="emailBack()"
      (continueEmail)="emailContinue($event)"
      (deleteCartDoc)="updateStorage($event)"
      [gridData]="dialogData"
      (emptyCart)="emptyCart($event)"
    ></ft-literature-dialog>
  </div>
</div>
<eds-sticky-footer
  [itemCount]="rowCountValue"
  [isHide]="rowCount === 0"
  variation="2"
  [primaryAction]="emailStickyButton"
  [secondaryAction]="downloadStickyButton"
  [tertiaryAction]="addToCartStickyButton"
  (btnSubscribePrimary)="operationToPerform('email')"
  (btnSubscribeSecond)="operationToPerform('download')"
  (btnSubscribeThird)="operationToPerform('addToCart')"
  [stickyFooterName]="'document_listing_sticky_footer'"
></eds-sticky-footer>
